<div class="dialog">
  <h1>{{'Confirmation' | translate}}</h1>
  <p>{{text | translate}}</p>
  <div class="row right">
    <button mat-flat-button mat-dialog-close>{{'Cancel' | translate}}</button>
    <button mat-flat-button (click)="onOK()">{{'OK' | translate}}</button>
  </div>
</div>
